
import React, { useState } from "react";
import Sidenav from "./components/Sidenav";
import Singleproducts from "./components/orders/getsingleproduct";

function Singleorders( ) {
    
  return (
    <div className="flex ">
       <div className="">
       <Sidenav />
       </div>
        <div className="">
            <Singleproducts />
        </div>
    </div>
  );
}

export default Singleorders;
